// -----------Importar Componentes de Terceros---------------------
import React from 'react';
import { useNavigate } from 'react-router-dom'

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
 


const NotaVenta = ({NoButton = false, Folio, ListCarritoIncluido, HorizontalLinearStepper, StyleDragArea, ListHeadersStep, StepLenght, handleClick, formatearComoMonedaMXN, Step_Pago, SubTotalExtra, SubTotal, Step_Extra, Step_PersonalizaSet, TotalServicioDespedida, ListTypo, FormActualizar, SetNombreSeleccionado }) => {
  const navigate = useNavigate()
  const HandleClick = (link) => {
    navigate(link)
  }

const CopiarFolio = () => {
    const folio = Folio;

    // Guardar en sessionStorage
    sessionStorage.setItem("folio", folio);
};
  
  return (
    <div >
      <Box mt='24px' className="col-sm-12" sx={{ display: { xs: 'none', md: 'block' } }}>
      </Box>
      <div style={{ margin: ' 0%', padding: '0%', borderRadius: '10px', backgroundColor: 'white', border: '3px solid', borderColor: '#D14081' }} className="col-md-12 row">
        <div style={{ marginTop: '15px' }} className='col-md-12'>
          <Typography display="inline" sx={{ fontWeight: 'bold !important',fontSize: '18px' }}>Servicio</Typography> 
        </div>
        <div style={{ marginTop: '0px', display: 'flex', justifyContent: 'space-between' }} className='col-md-12'>
          <Typography display="inline" sx={{ color: '#D14081', fontWeight: 'bold !important' ,fontSize: '18px'}}>{SetNombreSeleccionado}, {ListTypo.find((element) => (element.id === FormActualizar.TipoDespedida)).Nombre}</Typography>
          <Typography display="inline" sx={{ color: '#D14081',fontWeight: 'bold !important' ,fontSize: '18px'}}>{formatearComoMonedaMXN(TotalServicioDespedida)}</Typography>
        </div>
        <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'space-between' }} className='col-md-12'>
          <Typography display="inline" sx={{ fontWeight: 'bold !important',fontSize: '18px' }}>Productos</Typography>   <Typography display="inline" sx={{ fontWeight: 'bold !important',fontSize: '18px' }}>{formatearComoMonedaMXN(SubTotal - TotalServicioDespedida)}</Typography>
        </div>
        <ul>
          {
            Step_PersonalizaSet.ListCarrito.map((element, index) => {
              let cantidadASumar = 0;
              const productoEncontrado = Step_PersonalizaSet.ListProductos.find((producto) => (producto.producto === element.producto && producto.grupo === element.grupo));
              if (productoEncontrado && productoEncontrado.valor_default === 1) {
              } else {
                const productosEnMismoGrupo = Step_PersonalizaSet.ListProductos.filter((producto) => (producto.grupo === element.grupo && producto.valor_default === 1));
                cantidadASumar = element.precio_venta - productosEnMismoGrupo[0].precio_venta;
              }
              return (
                <li style={{ margin: '0px 0px 0px 30px' }} key={index}>
                  <div div className='col-md-12' style={{ margin: '0% 0%', display: 'flex', justifyContent: 'space-between' }} key={index}>
                    <Typography className={cantidadASumar !== 0 ? "c_rosa" : "c_negro"} display="inline" sx={{ fontSize: '16px' }}> {element.nombre_prodcto}</Typography>   <Typography className={cantidadASumar !== 0 ? "c_rosa" : "c_negro"} display="inline" sx={{ fontSize: '16px' }}>{formatearComoMonedaMXN(cantidadASumar !== 0 ? cantidadASumar : 0)}</Typography>
                  </div>
                </li>

              )
            })
          }
        </ul>



        <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'space-between' }} className='col-md-12'>
          <Typography display="inline" sx={{ fontWeight: 'bold !important' ,fontSize: '18px'}}>Servicios Incluidos</Typography>   <Typography display="inline" sx={{ fontWeight: 'bold !important',fontSize: '18px' }}>{formatearComoMonedaMXN(0)}</Typography>
        </div>
        <ul>
          {
            ListCarritoIncluido.map((item, index) => (

            <li key={index} style={{ margin: '0px 0px 0px 30px' }}>
              <div div className='col-md-12' style={{ margin: '0% 0%', display: 'flex', justifyContent: 'space-between' }} >
                <Typography className="c_negro" display="inline" sx={{ fontSize: '16px' }}> {item.nombre_prodcto}</Typography>   <Typography className="c_negro" display="inline" sx={{ fontSize: '16px' }}>{formatearComoMonedaMXN(0)}</Typography>
              </div>
            </li>
            ))
          }

        </ul>

        <div style={{ marginBottom: '5px', marginTop: '15px', display: 'flex', justifyContent: 'space-between' }} className='col-md-12'>
          <Typography display="inline" sx={{ fontWeight: 'bold !important',fontSize: '18px' }}>Extras</Typography>   <Typography display="inline" sx={{ fontWeight: 'bold !important',fontSize: '18px' }}>{formatearComoMonedaMXN(SubTotalExtra)}</Typography>
        </div>

        <ul>
          {
            Step_Extra.ListCarritoExtras.map((element, index) => (
              <li style={{ margin: '0px 0px 0px 30px' }} key={index}>
                <div className='col-md-12' style={{ margin: '0% 0%', display: 'flex', justifyContent: 'space-between' }} key={index}>
                  <Typography display="inline" sx={{ fontSize: '16px' }}>{element.cantidad}  {element.nombre_prodcto}</Typography>   <Typography display="inline" sx={{ fontSize: '16px' }}>{formatearComoMonedaMXN(element.precio_venta * element.cantidad)}</Typography>
                </div>
              </li>

            ))
          }
        </ul>

        <div style={{ marginBottom: '5px', marginTop: '15px', display: 'flex', justifyContent: 'space-between' }} className='col-md-12'>
          <Typography display="inline" sx={{ fontWeight: 'bold !important',fontSize: '18px' }}>Descuentos</Typography>   <Typography display="inline" sx={{ fontWeight: 'bold !important',fontSize: '18px' }}>-{formatearComoMonedaMXN(Step_Pago.FormPago.Descuento)}</Typography>
        </div>

        {
          Step_Pago.FormPago.FolioCupon == ''
            ? <></>
            :
            <ul>
              <li style={{ margin: '0px 0px 0px 30px' }}>
                <div div className='col-md-12' style={{ margin: '0% 0%', display: 'flex', justifyContent: 'space-between' }} >
                  <Typography className="c_rosa" display="inline" sx={{ fontSize: '16px' }}>{Step_Pago.FormPago.FolioCupon}</Typography>   <Typography className="c_negro" display="inline" sx={{ fontSize: '16px' }}>-{formatearComoMonedaMXN(Step_Pago.FormPago.Descuento)}</Typography>
                </div>
              </li>
            </ul>
        }





        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px  0px 15px 0px',padding:'0px 12px', borderColor: '#D14081', color: '#D14081' }}>
        <Typography sx={{ fontWeight: 'bold !important',fontSize: '18px' }} >Total: </Typography>  <Typography sx={{ fontWeight: 'bold !important',fontSize: '18px' }} >{formatearComoMonedaMXN(SubTotalExtra + SubTotal - Step_Pago.FormPago.Descuento)} </Typography>
        </div>
      </div>
      {
        NoButton
        ?
        <></>
        :
        <Box sx={{ width: '100%', marginBottom:{xs:'0px !important', sm:'0px !important'}, marginTop: '25px', display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' } }}>
        <StyleDragArea>
          <button type="button" style={{ width: '200px', backgroundColor: '#D14081 !important', borderColor: '#D14081 !important' }} onClick={() => {CopiarFolio();handleClick===''?HandleClick('/Conmemoraciones'):handleClick('/Conmemoraciones')}} className="btn btn_rosa" id="hola" >Ir a la conmemoración</button>
        </StyleDragArea>
      </Box>
      }
      
    </div>
  );
}


export default NotaVenta;